import React, { useState } from "react";
import { createPortal } from "react-dom";
import MessageUserButtonGate from "../messages/MessageUserButtonGate";
import UserAvatar from "../UserAvatar";
import { formatFishingType } from "../../utils/fishLabelsRu";
import { formatSpotCommentPeriod, formatYmdHi } from "../../utils/formatDateTime";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

function normalizeDetail(value) {
    return typeof value === "string" ? value.trim() : value;
}

function PhotoStrip({ photos, label }) {
    const [lightbox, setLightbox] = useState(null);
    if (!photos?.length) return null;
    return (
        <div style={{ marginTop: 6 }}>
            <span style={{ fontSize: "0.75em", color: "#888" }}>{label}</span>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginTop: 2 }}>
                {photos.map((src, i) => (
                    <img
                        key={i}
                        src={`${API_BASE_URL}${src}`}
                        alt={`${label} ${i + 1}`}
                        width={56}
                        height={56}
                        decoding="async"
                        onClick={() => setLightbox(src)}
                        style={{ width: 56, height: 56, objectFit: "cover", borderRadius: 4, cursor: "pointer" }}
                    />
                ))}
            </div>
            {lightbox && createPortal(
                <div className="comment-photo-lightbox" onClick={() => setLightbox(null)}>
                    <button
                        type="button"
                        className="comment-photo-lightbox__close"
                        onClick={(e) => {
                            e.stopPropagation();
                            setLightbox(null);
                        }}
                        aria-label="Закрыть фото"
                    >
                        ×
                    </button>
                    <img
                        src={`${API_BASE_URL}${lightbox}`}
                        alt="Предпросмотр фотографии"
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>,
                document.body,
            )}
        </div>
    );
}

export default function CommentItem({ comment }) {
    const labelLang = "ru";
    const name = comment.user || "Пользователь";
    const commentUser = {
        id: comment.userId,
        username: comment.user,
        allowPrivateMessages: Boolean(comment.userAllowPrivateMessages),
    };
    const period = formatSpotCommentPeriod(comment.startTime, comment.endTime);
    const gearLabel = formatFishingType(comment.fishingType, labelLang);
    const details = [
        ["Снасть", gearLabel],
        ["Прикормка", normalizeDetail(comment.groundbait)],
        ["Наживка", normalizeDetail(comment.baitUsed)],
        ["Что поймали", normalizeDetail(comment.whatCaught)],
        ["Глубина", normalizeDetail(comment.depth)],
    ].filter(([, value]) => value);
    const added = formatYmdHi(comment.createdAt);

    return (
        <article className="comment-item">
            <UserAvatar avatarUrl={comment.userAvatarUrl} name={name} className="comment-item__avatar" size={52} />
            <div className="comment-item__body">
                <div className="comment-item__head">
                    <div className="comment-item__name-row">
                        <strong>{name}</strong>
                        <MessageUserButtonGate user={commentUser} />
                    </div>
                    {added ? <span className="comment-item__date">{added}</span> : null}
                </div>
                {period ? <div className="comment-item__period">{period}</div> : null}
                {details.length ? (
                    <div style={{ fontSize: "0.8em", marginTop: 4 }}>
                        {details.map(([label, value], index) => (
                            <React.Fragment key={label}>
                                {index > 0 ? " · " : null}
                                <b>{label}:</b> {value}
                            </React.Fragment>
                        ))}
                    </div>
                ) : null}
                <p style={{ marginTop: 8 }}>{comment.comment || "-"}</p>
                <PhotoStrip photos={comment.placePhotos} label="Место" />
                <PhotoStrip photos={comment.catchPhotos} label="Улов" />
                <PhotoStrip photos={comment.depthPhotos} label="Глубина" />
            </div>
        </article>
    );
}
